import { IChoiceGroupStyles } from '@fluentui/react';

export const choiceGroupStyles: IChoiceGroupStyles = {
  label: {
    display: 'inline',
  },
  flexContainer: {
    display: 'inline-flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'relative',
    top: -5,
    selectors: {
      '> *': {
        marginRight: 16,
      },
      '> *:last-child': {
        marginRight: 0,
      },
    },
  },
};
export const rowSelectorGroupStyles: IChoiceGroupStyles = {
  label: {
    display: 'inline',
  },
  flexContainer: {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 150,
    position: 'relative',
    top: -5,
    justifyContent: 'space-between',
  }
};